import { DefaultContext, FetchResult, MutationResult, useMutation } from '@apollo/client';

import {
  ClearAscProjectApprovalMutation,
  ClearAscProjectApprovalMutationVariables,
  CLEAR_ASC_PROJECT_APPROVAL,
  PeriodName,
} from '@neo.tax/shared';

type UseClearAscProjectApprovalProps = {
  context?: DefaultContext;
};

type ClearAscProjectApprovalParams = {
  ascProjectId: string;
  fiscalYearId: string;
  periodName: PeriodName;
};

type UseClearAscProjectApproval = [
  (params: ClearAscProjectApprovalParams) => Promise<FetchResult<ClearAscProjectApprovalMutation>>,
  MutationResult<ClearAscProjectApprovalMutation>,
];

export const useClearAscProjectApproval = ({
  context: contextFromInit,
}: UseClearAscProjectApprovalProps = {}): UseClearAscProjectApproval => {
  const [clearAscProjectApprovalMutation, clearAscProjectApprovalMutationResult] = useMutation<
    ClearAscProjectApprovalMutation,
    ClearAscProjectApprovalMutationVariables
  >(CLEAR_ASC_PROJECT_APPROVAL, {
    context: {
      successToast: {
        title: 'Approval reset successfully',
      },
      errorToast: {
        title: 'Error resetting approval',
        description: 'Something unexpected prevented the reset. Please try again.',
      },
      ...contextFromInit,
    },
  });

  const clearAscProjectApproval = ({
    ascProjectId,
    fiscalYearId,
    periodName,
  }: ClearAscProjectApprovalParams): Promise<FetchResult<ClearAscProjectApprovalMutation>> =>
    clearAscProjectApprovalMutation({
      variables: {
        ascProjectId,
        fiscalYearId,
        periodName,
      },
    });

  return [clearAscProjectApproval, clearAscProjectApprovalMutationResult];
};
